<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="Normal"><span class="Bold CharOverride-3">T</span><span class="Bold CharOverride-4">he <br/>Best New <br/>True Crime <br/>Stories</span></p>
<p class="Normal ParaOverride-3"><span class="CharOverride-5">Unsolved <br/>Crimes <br/>&amp; Mysteries</span></p>
<p class="Normal ParaOverride-4"><span class="Bold CharOverride-6">Mitzi Szereto</span></p>
<p class="Normal ParaOverride-5"><span class="CharOverride-7"><img alt="" class="_idGenObjectAttribute-1" src="image/MangoPublishingLogo(grayscale).jpg"/></span></p>
<p class="Normal ParaOverride-6"><span class="CharOverride-8">Coral Gables</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TheBestNewTrueCrimeStories-3.vue?003254ac